import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Supply",
    links: [
      { label: "Industries", to: "/industries" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Request a Quote", to: "/quote" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t border-offwhite/10 bg-coal" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Logo />
            <p className="font-mono-tech text-xs uppercase tracking-[0.22em] text-strike mt-6">Mining Equipment Spare &amp; Wear Parts</p>
            <p className="text-mutedgray max-w-sm mt-6 leading-relaxed">
              Spare and wear parts for mining equipment — sourced from trusted global manufacturers, with competitive pricing and reliable supply.
            </p>
            <a href="mailto:info@blacksilex.com" className="inline-block mt-8 font-display text-2xl md:text-3xl font-bold text-offwhite link-underline" data-testid="footer-email">
              info@blacksilex.com
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {COLS.map((col) => (
              <div key={col.title}>
                <p className="tech-label text-mutedgray mb-5">{col.title}</p>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link to={l.to} className="text-mutedgray hover:text-strike transition-colors" data-testid={`footer-${l.label.replace(/\s+/g, "-").toLowerCase()}`}>
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-offwhite/10 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="font-mono-tech text-xs text-mutedgray tracking-[0.1em]">© 2026 BLACKSILEX — MINING EQUIPMENT SPARE PARTS</p>
          <p className="font-mono-tech text-xs text-mutedgray tracking-[0.1em]">MINING · CONSTRUCTION · ENERGY</p>
        </div>
      </div>
    </footer>
  );
}
